<template>
  <audio controls>
    <source class="mb-2 audio-component" v-bind:src="content.media" type="audio/mpeg">
    Your browser does not support the audio element.
  </audio>
</template>

<script>
    export default {
        name: "AudioComponent",
        props:{
            content: Object,
            idx: Number,
        },
        data(){
            return {
                response : null
            }
        },
    }
</script>

<style scoped>
  audio {
    max-height: 20px;
  }

</style>